const translations = {
  title: 'Actividades',
  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.unproductives': 'Motivos de Improductividad',
  'menu.disapproves': 'Motivos de rechazo',
  'menu.canceled': 'Motivos de cancelación',
  'menu.pendencies': 'Motivos de Pendencia',
  'menu.newTrigger': 'Crear automatización',
  'menu.triggers': 'Automatizaciones',
  'menu.integrations': 'Integraciones',
  'menu.fields': 'Personalizar campos adicionales',
  'menu.tags': 'Tags de Actividad',
  'menu.templates': 'Plantillas de PDF',
  'menu.templateHistory': 'Historial de Documento',
  'counter.text': 'Registros encontrados',
  'menu.publicToken': 'Tokens públicos',
  'menu.semaphore': 'Configuración de semáforo',
  'menu.sla': 'Configurar SLA',
  'menu.routines': 'Rutinas',
  'menu.configurations.automatic.distribution': 'Configurar distribución automática',
  'search.normal': 'Búsqueda normal',
  'search.reply': 'Búsqueda por respuesta',
  'search.field': 'Búsqueda por campo adicional',
  'search.place': 'Búsqueda por destino',
  'table.code': 'Código',
  'table.responsible': 'Responsable',
  'table.destination': 'Destino',
  'table.scheduling': 'Agendamiento',
  'table.completion': 'Conclusión',
  'table.sla': 'SLA',
  'table.status': 'Estado',
  'table.priority': 'Prioridad',
  'table.tag': 'Tag',
  'table.openedAt': 'Abierto en',
  'error.unexpected': 'Error inesperado al crear actividad'
}

export default translations
